// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"c2deecde","467":"f3020510","496":"fd08778c","536":"7ebcf2e1"}[chunkId] + ".chunk.js";
};